<template>
    <v-container>
        <v-row>
            <v-col>
                <v-row>
                    <v-col> <div class="headline">ETATER: SMS-TILGANG</div> </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title>
                                <div>Etater</div>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="addAgency">
                                    <v-icon left>mdi-plus</v-icon>
                                    legg til etat
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-data-table @item-selected="itemSelected" show-select single-select :items="agencies" :headers="agencyHeaders" hide-default-footer disable-pagination mobile-breakpoint="-1">
                                    <template v-slot:[`item.name`]="{ item }">
                                        <div v-if="item.viewmodel.edit" class="d-flex align-center">
                                            <v-text-field :ref="item.viewmodel.key" v-model="item.name" label="navn" @keyup.enter="confirmEditAgency(item)" @keyup.esc="cancelEditAgency(item)"></v-text-field>
                                            <v-btn color="error" icon @click="cancelEditAgency(item)"><v-icon>mdi-close</v-icon></v-btn>
                                            <v-btn color="success" icon @click="confirmEditAgency(item)" :disabled="!canConfirmEditAgency(item)"><v-icon>mdi-check</v-icon></v-btn>
                                        </div>
                                        <div v-else class="d-flex align-center" style="cursor: pointer" @click="editAgency(item)">
                                            <div>{{ item.name }}</div>
                                            <v-icon right small>mdi-pencil</v-icon>
                                        </div>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <div>
                                            <v-btn v-if="!item.viewmodel.confirmDelete" icon color="error" @click="deleteAgency(item)"><v-icon>mdi-delete</v-icon></v-btn>
                                            <v-btn v-else icon color="error" @click="deleteAgency(item)"><v-icon>mdi-crosshairs-question</v-icon></v-btn>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card :disabled="!agency">
                            <v-card-title>
                                <div v-if="agency">
                                    SMS-tilgang: <span class="font-weight-bold text-uppercase">{{ agency.name }}</span>
                                </div>
                                <div v-else>Velg en etat...</div>
                                <v-spacer></v-spacer>
                                <v-btn color="success" :disabled="!canAddAccessCode" @click="addAccessCode">
                                    <v-icon left>mdi-plus</v-icon>
                                    legg til SMS-tilgang
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-data-table :items="agency && agency.accessCodes ? agency.accessCodes : []" :headers="accessCodeHeaders" hide-default-footer disable-pagination mobile-breakpoint="-1">
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-btn v-if="!item.viewmodel.deleteConfirm" icon color="error" @click="deleteAccessCode(item)"><v-icon>mdi-delete</v-icon></v-btn>
                                        <v-btn v-else icon color="error" @click="deleteAccessCode(item)"><v-icon>mdi-crosshairs-question</v-icon></v-btn>
                                    </template>
                                    <template v-slot:[`item.code`]="{ item }">
                                        <div v-if="item.viewmodel.edit" class="d-flex align-center">
                                            <v-text-field :ref="item.viewmodel.key" label="kode" v-model="item.code" @keyup.enter="confirmEditAccessCode(item)" @keyup.esc="cancelEditAccessCode(item)"></v-text-field>
                                            <v-btn color="error" icon @click="cancelEditAccessCode(item)"><v-icon>mdi-close</v-icon></v-btn>
                                            <v-btn color="success" icon @click="confirmEditAccessCode(item)" :disabled="!canSaveAccessCode(item)"><v-icon>mdi-check</v-icon></v-btn>
                                        </div>
                                        <div v-else class="d-flex align-center" style="cursor: pointer" @click="editAccessCode(item)">
                                            <div>{{ item.code }}</div>
                                            <v-icon small right>mdi-pencil</v-icon>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
export default {
    data() {
        return {
            agencyHeaders: [
                { text: "Navn", value: "name", width: "70%" },
                { text: "SMS-koder", value: "accessCodes.length", width: "20%" },
                { text: "Fjern", value: "actions", width: "10%" },
            ],

            agencies: [],

            agency: undefined,

            accessCodeHeaders: [
                { text: "Kode", value: "code", width: "70%" },
                { text: "Claims", value: "claims", width: "20%" },
                { text: "Fjern", value: "actions", width: "10%" },
            ],
        };
    },
    computed: {
        canAddAccessCode() {
            if (!this.agency) {
                return false;
            }

            return !this.agency.accessCodes.some((accessCode) => accessCode.viewmodel.edit);
        },
    },
    methods: {
        canSaveAccessCode(accessCode) {
            return accessCode.code?.trim().length > 0;
        },
        itemSelected: function (selection) {
            if (selection.value) {
                this.agency = selection.item;
            } else {
                this.agency = undefined;
            }
        },
        async deleteAccessCode(accessCode) {
            if (!accessCode.viewmodel.deleteConfirm) {
                this.$set(accessCode.viewmodel, "deleteConfirm", true);
                accessCode.viewmodel.timeout = setTimeout(() => {
                    this.$set(accessCode.viewmodel, "deleteConfirm", false);
                }, 1500);
                return;
            }

            if (accessCode.viewmodel.timeout) {
                clearTimeout(accessCode.viewmodel.timeout);
            }

            let response = await axios.delete(`/agency/delete/accesscode/${accessCode.id}`);
            if(!response.data.success){
                this.$store.dispatch("snackbar",{
                    show: true,
                    text: "feilet",
                    color: "error"
                });
                return;
            }

            let index = this.agency.accessCodes.findIndex((ac) => ac === accessCode);
            if (index >= 0) {
                this.agency.accessCodes.splice(index, 1);
            }
        },

        addAccessCode() {
            let accessCode = {
                code: "",
                agency_id: this.agency.id,
                claims: 0,
                reuse: 0,
                type: 0,
                viewmodel: {
                    key: `accessCode_${Math.random()}`,
                },
            };

            this.agency.accessCodes.push(accessCode);

            this.$nextTick(() => {
                this.editAccessCode(accessCode);
            });
        },
        editAccessCode(accessCode) {
            // only one accessCode can be edited at a time
            let halt = false;
            this.agency.accessCodes.forEach(async (ac) => {
                if (ac === accessCode) {
                    return;
                }

                if (ac.viewmodel.edit) {
                    halt = !(await this.confirmEditAccessCode(ac));
                }
            });

            if (halt) {
                return;
            }

            if (accessCode.viewmodel.edit) {
                this.$set(accessCode.viewmodel, "edit", false);
            } else {
                accessCode.viewmodel.original = { code: accessCode.code };

                this.$set(accessCode.viewmodel, "edit", true);
                this.$nextTick(() => {
                    // console.log(this.$refs);
                    // console.log(accessCode.viewmodel.key);
                    this.$refs[accessCode.viewmodel.key].autofocus = true;
                });
            }
        },
        async confirmEditAccessCode(accessCode) {
            if (accessCode.code.trim().includes(" ")) {
                this.$store.dispatch("snackbar", {
                    show: true,
                    text: "mellomrom ikke tillatt",
                    color: "error",
                });
                return false;
            }

            delete accessCode.viewmodel.original;
            accessCode.code = accessCode.code.trim();

            let dto = Object.assign({}, accessCode);
            delete dto.viewmodel;

            if (accessCode.id) {
                let response = await axios.post("/agency/update/accesscode", dto);
                if (!response.data.success) {
                    return false;
                }
            } else {
                let response = await axios.post("/agency/create/accesscode", dto);
                if (!response.data.success) {
                    return false;
                }
                accessCode.id = response.data.data.id;
            }

            this.$set(accessCode.viewmodel, "edit", false);
            return true;
        },
        cancelEditAccessCode(accessCode) {
            accessCode.code = accessCode.viewmodel.original.code;
            delete accessCode.viewmodel.original;

            this.$set(accessCode.viewmodel, "edit", false);
        },
        async addAgency() {
            let agency = {
                name: "",
                active: true,
                contactPerson: "",
                contactNumber: "",
                accessCodes: [],
                viewmodel: {
                    key: `agency_${Math.random()}`,
                },
            };
            // let response = await axios.post("/agency/create", agency);
            // debugger;
            // let _agency = response.data.data;
            // _agency.viewmodel = {
            //     key: `agency_${Math.random()}`,
            // }

            this.agencies.push(agency);

            this.editAgency(agency);
        },
        editAgency(agency) {
            agency.viewmodel.original = {
                name: agency.name,
            };

            this.$set(agency.viewmodel, "edit", true);
            this.$nextTick(() => {
                this.$refs[agency.viewmodel.key].autofocus = true;
            });
        },
        cancelEditAgency(agency) {
            agency.name = agency.viewmodel.original.name;
            delete agency.viewmodel.original;

            this.$set(agency.viewmodel, "edit", false);
        },
        canConfirmEditAgency(agency) {
            return agency.name.trim().length > 0;
        },
        async confirmEditAgency(agency) {
            // if (agency.name.trim().includes(" ")) {
            //     this.$store.dispatch("snackbar", {
            //         show: true,
            //         text: "mellomrom ikke tillatt",
            //         color: "error",
            //     });
            //     return false;
            // }

            agency.name = agency.name.trim();

            try {
                if (agency.id) {
                    let dto = Object.assign({}, agency);
                    delete dto.viewmodel;
                    await axios.post("/agency/update", dto);
                } else {
                    let dto = Object.assign({}, agency);
                    delete dto.viewmodel;
                    let response = await axios.post("/agency/create", dto);
                    if (!response.data.success) {
                        throw new Error("Etat lagring feilet");
                    }

                    agency.id = response.data.data.id;
                }
            } catch (err) {
                this.$store.dispatch("snackbar", {
                    show: true,
                    text: "etat lagring feilet",
                    color: "error",
                });
                return;
            }

            this.$set(agency.viewmodel, "edit", false);
            return true;
        },
        async deleteAgency(agency) {
            if (!agency.viewmodel.confirmDelete) {
                this.$set(agency.viewmodel, "confirmDelete", true);
                agency.viewmodel.timeout = setTimeout(() => {
                    this.$set(agency.viewmodel, "confirmDelete", false);
                }, 1500);
                return;
            }

            if (agency.viewmodel.timeout) {
                clearTimeout(agency.viewmodel.timeout);
            }

            if (agency.id) {
                try {
                    await axios.delete(`/agency/delete/${agency.id}`);
                } catch (err) {
                    this.$store.dispatch("snackbar", {
                        show: true,
                        text: "sletting av etat feilet",
                        color: "error",
                    });
                    return;
                }
            }

            let index = this.agencies.findIndex((a) => a === agency);
            if (index >= 0) {
                this.agencies.splice(index, 1);
            }

            if (this.agency === agency) {
                this.agency = undefined;
            }
        },
        loadAgencies: function () {
            axios.get("/agency").then((response) => {
                if (response.data.success) {
                    let agencies = response.data.data;

                    agencies.forEach((agency) => {
                        agency.viewmodel = {
                            key: `agency_${Math.random()}`,
                        };

                        agency.accessCodes.forEach((accessCode) => {
                            accessCode.viewmodel = {
                                key: `accessCode_${Math.random()}`,
                            };
                        });
                    });

                    this.agencies = agencies;
                } else {
                    this.$store.dispatch("snackbar", {
                        show: true,
                        text: "kunne ikke laste ned etater",
                        color: "error",
                    });
                }
            });

            // let agencies = [
            //     {
            //         id: 1,
            //         name: "politi oslo",
            //         active: true,
            //         contactPerson: "Jan Bøhler",
            //         contactNumber: "112",
            //         accessCodes: [
            //             {
            //                 id: 1522,
            //                 code: "oslopol34324",
            //                 agency_id: 1,
            //                 claims: 100,
            //             },
            //             {
            //                 id: 1523,
            //                 code: "oslopol1523",
            //                 agency_id: 1,
            //                 claims: 555,
            //             },
            //         ],
            //     },
            //     {
            //         id: 2,
            //         name: "mattilsynet oslo",
            //         active: true,
            //         contactPerson: "Kirk Douglas",
            //         contactNumber: "1234245345",
            //         accessCodes: [
            //             {
            //                 id: 1528,
            //                 code: "mt123",
            //                 agency_id: 2,
            //                 claims: 0,
            //             },
            //             {
            //                 id: 1899,
            //                 code: "mt5534123",
            //                 agency_id: 2,
            //                 claims: 123,
            //             },
            //         ],
            //     },
            // ];
        },
    },
    mounted() {
        this.loadAgencies();
    },
};
</script>